module.exports = __webpack_public_path__ + "media/images/icon-text-8d2d0d6f035c53aad85fac5afa3f5c53.svg";